import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { splitProfileListService } from "services";
import { uiActions } from "store";
import { ChangeSplitProfileStatusProps, ErrorResponse } from "types";

const useUpdateSplitProfileStatusMutation = onSuccess => {
	const dispatch = useDispatch();

	return useMutation(
		({
			agentId,
			splitProfileId,
			status,
		}: ChangeSplitProfileStatusProps) => {
			dispatch(uiActions.showSpinnerOverlay());
			return splitProfileListService.changeSplitProfileStatus({
				agentId,
				splitProfileId,
				status,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateSplitProfileStatusMutation;
